import type { ButtonColor } from './colors';

export const tertiaryColors: Partial<Record<ButtonColor, string>> = {
  'brand-primary': 'text-brand-primary-700 hover:bg-brand-primary-50',
  'brand-secondary': 'text-brand-secondary-700 hover:bg-brand-secondary-50',
  gray: 'text-text-secondary-600 hover:bg-text-secondary-100',
  white: 'text-text-primary-inverse focus-visible:ring-white focus-visible:ring-offset-black hover:bg-surface-veil-10',
};
